import { MokaiDocumentType } from '../../../model/dossier.model'

export const supportsFileType = (filetype: string) => {
    switch (filetype) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'pdf':
        case 'ppt':
        case 'pptx':
        case 'doc':
        case 'docx':
        case 'xml':
        case 'xslt':
        case 'xsl':
        case 'csv':
        case 'txt':
        case 'odt':
        case 'rtf':
        case 'log':
        case 'md':
        case 'htm':
        case 'html':
        case 'webP':
        case 'svg':
        case 'url':
        case 'zip':
        case 'tiff':
            return true
        default:
            return false
    }
}

/**
 * This function takes a filename and returns the filename without the ending (i.e. the file-type identifier)
 * e.g. "arzteugnis.pdf" turns into "arztzeugnis"
 * @param name
 */
export const cutEnding = (name: string) => {
    const spl = name.split('.')
    spl.pop()
    return spl.join('')
}

/**
 * The document type defines the business type of the document
 * @param name
 * @param types
 * @returns id of the document type or default type "other" 1
 */
export const getDocumentType = (name: string, types: MokaiDocumentType[]) : number => {

    for (let type of types) {
        if (name.toLowerCase().includes(type.document_type_name.toLowerCase())) {
            return type.document_type_id
        }
    }

    if (name.toLowerCase().startsWith('sp-') || name.toLowerCase().startsWith('kk-')) {
        const spesen = types.find(e => e.document_type_name === 'Spesen')

        if (spesen) {
            return spesen.document_type_id
        }
    }

    if (name.toLowerCase().startsWith('re-') || name.toLowerCase().includes('invoice')) {
        const rechnung = types.find(e => e.document_type_name === 'Rechnung')
        if (rechnung) {
            return rechnung.document_type_id
        }
    }

    // if the case is not handled return the default "other" ("Sonstiges")
    return 1
}

/**
 * Max length for dossier naming.
 */
export const MAX_DOSSIER_NAME_LENGTH = 45
/**
 * Max length for a comment. the database allows "text"
 */
export const MAX_DOSSIER_COMMENT_LENGTH = 300